module.exports = __webpack_public_path__ + "img/6.1d9b5233.jpg";